export const MuiDialogActions = {
    styleOverrides: {
        root: {
            padding: "8px 32px"
        }
    }
};
//# sourceMappingURL=DialogActions.js.map